import { publicInstance } from "../config/axios"

export const getEducationalVideo = async (uuid) => {
  const response = await publicInstance.get(`/educational-videos/${uuid}`)
  return response.data
}

// QR-code scan tracking. Answers 204 with no body, and never rejects in a way
// the page should react to — the caller treats it as fire-and-forget.
export const logEducationalVideoEvent = async ({ uuid, ...payload }) => {
  await publicInstance.post(`/educational-videos/${uuid}/events`, payload)
}

// Video playback tracking (loaded/started/percent/step/ended, play/pause/
// waiting state, watched-seconds). Same fire-and-forget contract.
export const logEducationalVideoPlayerEvent = async ({ uuid, ...payload }) => {
  await publicInstance.post(
    `/educational-videos/${uuid}/player-events`,
    payload
  )
}
